module.exports = __webpack_public_path__ + "static/media/image06.4e95b626.png";